import xhr from 'xhr';

export default async function getstudentPayments(data) {
  const res = await xhr(`/payments?filters[student][id][$eq]=${data.id}&sort[0]=createdAt:DESC&populate=deep,2`);

  return res.data.data;
}
